import { TweenMax as TM } from 'gsap/all'
import Scrollbar from 'smooth-scrollbar'
import { map } from './utils/utils'

import Scene from './Scene'

const offsetTitle = 100


export default class Stage {

    constructor() {
        this.progress = 0

        this.$els = {
            title       : document.querySelector('.page-title'),
            progress    : document.querySelector('.slideshow__progress'),
            progressCtn : document.querySelector('.slideshow__progress-ctn'),
            scene       : document.getElementById('scene'),
        }


        this.init()
    }

    init() {
        this.scene = new Scene(this.$els.scene)
    }


    /* Handlers
    --------------------------------------------------------- */


    /* Actions
    --------------------------------------------------------- */


    /* Values
    --------------------------------------------------------- */


}
